import dashboardConstants from "../constants/dashboardConstants";

const initialState: {
  incomeSummary: any;
  clientTypeincome: any;
  incomeChartData: any;
  paymentChartData: any;
  topClients: any;
  topPlatforms: any;
} = {
  incomeSummary: null,
  clientTypeincome: null,
  incomeChartData: null,
  paymentChartData: null,
  topClients: null,
  topPlatforms: null,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case dashboardConstants.GET_INCOME_SUMMARY_SUCCESS:
      return {
        ...state,
        incomeSummary: action.payload.data.results,
      };
    case dashboardConstants.GET_CLIENT_TYPE_INCOME_SUCCESS:
      return {
        ...state,
        clientTypeincome: action.payload.data.results,
      };
    case dashboardConstants.GET_INCOME_CHART_DATA_SUCCESS:
      return {
        ...state,
        incomeChartData: action.payload.data.results,
      };
    case dashboardConstants.GET_PAYMENT_CHART_DATA_SUCCESS:
      return {
        ...state,
        paymentChartData: action.payload.data.results,
      };
    case dashboardConstants.GET_TOP_EARNING_ACCOUNT_SUCCESS:
      return {
        ...state,
        topClients: action.payload.data.results,
      };
    case dashboardConstants.GET_TOP_EARNING_PLATFORM_SUCCESS:
      return {
        ...state,
        topPlatforms: action.payload.data.results,
      };
    default:
      return {
        ...state,
      };
  }
};
